// extracted by mini-css-extract-plugin
export default {"content":"TALjZ","texts":"bURk3","image":"V0QrN","image--left":"sqodC","image--center":"BeYRv","image--right":"GQCkI"};